import React from 'react';
import {FormattedMessage} from 'react-intl';

function escapeSymbols(text) {
  return (text || '-')
    .replace(/{registered}/g, '\u00AE')
    .replace(/{trademark}|{trade}/g, '\u2122');

}

class ProductProfile extends React.Component {
  state = {
  };

  checkSanitizerReg = (sanitizer) => {
    let output;
    let indexOfReg = sanitizer.indexOf('{registered}');

    if(indexOfReg > -1) {
      return <span>{sanitizer.substring(0, indexOfReg)} &reg; {sanitizer.substring(indexOfReg + 12, sanitizer.length)}</span>;
    }
    return output;
  };

  systemClick = (system) => {
    window.location.hash = `#customer/${this.props.customerID}/${system}/details`;
  };

  render() {

    const products = this.props.products.map((product, i) =>
      <div key={i}>
        <div className="rvp-title">
          <h2><FormattedMessage id="general.product.profile" />: {product.SanitizerType}</h2>
          <a onClick={this.systemClick.bind(this, product.ID)}><FormattedMessage id="general.view.system" /><i className='bl bl-right_arrow' /></a>
        </div>
        <div className="container-fluid product-profile">
          <div className="row">
            <div className="col-sm-3">
              <label><FormattedMessage id="general.sanitizer" /></label><br />
              <span>{escapeSymbols(product.Sanitizer)}</span>
            </div>
            <div className="col-sm-3">
              <label><FormattedMessage id="general.maint.oxidizer" /></label><br />
              <span>{escapeSymbols(product.MaintOxidizer)}</span>
            </div>
            <div className="col-sm-3">
              <label><FormattedMessage id="general.prev.algicide" /></label><br />
              <span>{escapeSymbols(product.PrevAlgaecide)}</span>
            </div>
            <div className="col-sm-3"/>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <label><FormattedMessage id="customer.product.profile.troubleshooting" /></label><br />
              <span>{escapeSymbols(product.MaintOxidizer)}</span>
            </div>
            <div className="col-sm-3">
              <label><FormattedMessage id="customer.product.profile.phadjuster" /></label><br />
              <span>{escapeSymbols(product.pHAdjuster)}</span>
            </div>
            <div className="col-sm-3">
              <label><FormattedMessage id="customer.product.profile.maintclarifer" /></label><br />
              <span>{escapeSymbols(product.MaintClarifer)}</span>
            </div>
            <div className="col-sm-3">
              <label><FormattedMessage id="customer.product.profile.winterizer" /></label><br />
              <span>{escapeSymbols(product.Winterizer)}</span>
            </div>
          </div>
        </div>
      </div>
		);

    return (
      <div>
        {products}
      </div>
    );
  }
}

export default ProductProfile;
